import { useContext } from "react";
import { MapPin, Mail, Fingerprint, Phone } from "lucide-react";
import { LanguageContext } from "@/i18n";

export default function Footer() {
  const { t } = useContext(LanguageContext);

  return (
    <footer data-testid="footer-section" className="relative border-t border-white/10 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center opacity-[0.14]"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1696711551721-458511adcd86?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxpc3RhbmJ1bCUyMHNreWxpbmUlMjBuaWdodHxlbnwwfHx8fDE3ODYxNzc5MTJ8MA&ixlib=rb-4.1.0&q=85')",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A] via-[#0A0A0A]/80 to-[#0A0A0A]" />

      <div className="relative max-w-screen-xl mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="grid md:grid-cols-3 gap-12 mb-16">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <span className="w-2.5 h-2.5 bg-[#00F0FF] rotate-45" />
              <span className="font-display font-black text-xl tracking-[0.18em] text-white">DADABIO</span>
            </div>
            <p className="text-sm font-light text-zinc-500 leading-relaxed max-w-xs">{t.footer.tagline}</p>
            <p data-testid="footer-company-name" className="mt-4 font-mono text-[11px] tracking-wide text-zinc-600">
              DADABIO İnovasyon Teknoloji Limited Şirketi
            </p>
          </div>

          <div className="flex flex-col gap-4">
            <div className="flex items-start gap-3 text-sm text-zinc-400">
              <MapPin size={15} className="text-[#00F0FF] mt-0.5 shrink-0" />
              <span data-testid="footer-hq">{t.footer.hq}</span>
            </div>
            <a data-testid="footer-phone-link" href="tel:+905360594292" className="flex items-center gap-3 text-sm text-zinc-400 hover:text-[#00F0FF] transition-colors duration-300">
              <Phone size={15} className="text-[#00F0FF] shrink-0" />
              +90 536 059 42 92
            </a>
            <a data-testid="footer-email-link" href="mailto:info@dadabio.com" className="flex items-center gap-3 text-sm text-zinc-400 hover:text-[#00F0FF] transition-colors duration-300">
              <Mail size={15} className="text-[#00F0FF] shrink-0" />
              info@dadabio.com
            </a>
            <div className="flex items-center gap-3 text-sm text-zinc-400">
              <Fingerprint size={15} className="text-[#00F0FF] shrink-0" />
              <span data-testid="footer-duns" className="font-mono text-[13px]">{t.footer.duns}</span>
            </div>
          </div>

          <div className="flex md:justify-end items-start gap-8">
            <a data-testid="footer-privacy-link" href="#" onClick={(e) => e.preventDefault()} className="text-sm text-zinc-500 hover:text-white transition-colors duration-300">
              {t.footer.privacy}
            </a>
            <a data-testid="footer-terms-link" href="#" onClick={(e) => e.preventDefault()} className="text-sm text-zinc-500 hover:text-white transition-colors duration-300">
              {t.footer.terms}
            </a>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10">
          <p data-testid="footer-rights" className="text-[13px] font-light text-zinc-600">{t.footer.rights}</p>
        </div>
      </div>
    </footer>
  );
}
